import { Fleet } from '@/types/utm/fleet.type';

import { UTM_URL, utmApi } from './utm.api';

export const fleetApi = utmApi.injectEndpoints({
  endpoints: (builder) => ({
    createFleet: builder.mutation<Fleet, Partial<Fleet>>({
      query: (fleet: Fleet) => ({
        url: `${UTM_URL}/fleets`,
        method: 'POST',
        body: fleet,
      }),
    }),
    updateFleet: builder.mutation<Fleet, Fleet>({
      query: (fleet) => ({
        url: `${UTM_URL}/fleets/${fleet.id}`,
        method: 'PUT',
        body: fleet,
      }),
    }),
    deleteFleet: builder.mutation<void, number>({
      query: (id) => ({
        url: `${UTM_URL}/fleets/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const { useCreateFleetMutation, useUpdateFleetMutation, useDeleteFleetMutation } = fleetApi;
